var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5234 7.02344V4L15.5 11.5234L3.47656 4V7.02344L15.5 14.4766L27.5234 7.02344ZM27.5234 0.976562C28.3203 0.976562 29 1.28125 29.5625 1.89062C30.1719 2.5 30.4766 3.20312 30.4766 4V22C30.4766 22.7969 30.1719 23.5 29.5625 24.1094C29 24.7188 28.3203 25.0234 27.5234 25.0234H3.47656C2.67969 25.0234 1.97656 24.7188 1.36719 24.1094C0.804688 23.5 0.523438 22.7969 0.523438 22V4C0.523438 3.20312 0.804688 2.5 1.36719 1.89062C1.97656 1.28125 2.67969 0.976562 3.47656 0.976562H27.5234Z",
    fill: "#445E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.04ac849a5c071f0eeb4a414af9b81386.svg";
export { ForwardRef as ReactComponent };